<app-landingpage-header-child></app-landingpage-header-child>

<section class="home-page pt-4 pb-4">
    <div class="container p-4">
        <div class="row">
            <div class="col-8 offset-2 text-center">
                <h4>{{'header.notify' | translate}}</h4>
                <h5 class="mb-4" *ngIf="isProvalSucess">{{'approved.approval_success' | translate}}</h5>
                <h5 class="mb-4" *ngIf="isRejectProvalSucess">{{'approved.reject_approval_success' | translate}}</h5>

                <button mat-stroked-button color="primary" type="button" routerLink="{{linkHome}}">
                    <mat-icon class="mr-0">arrow_back</mat-icon>
                    {{ 'update_enterprise.buttons.btn_back_home' | translate }}
                </button>
            </div>
        </div>
    </div>
</section>
<app-landingpage-footer></app-landingpage-footer>